import { MasterlistProductsParams } from '../../../models/index';
import axios, { AxiosRequestConfig } from '../../../services/axios';
import { notification } from 'syngenta-digital-cropwise-react-ui-kit';

const VITE_APP_API_URL = import.meta.env.VITE_APP_API_URL;

export const getMasterListProducts = async (
  params: MasterlistProductsParams,
  controller?: AbortController,
) => {
  try {
    const response = await axios.get(`${VITE_APP_API_URL}/valet/v2/product-masterlist`, {
      params,
      signal: controller?.signal,
    } as AxiosRequestConfig);
    return response.data;
  } catch (err: any) {
    notification.error({
      message: 'Error',
      description: 'Unable to locate Cropwise Resource data',
      placement: 'topRight',
    });
    return err;
  }
};
